import { PageHeader } from '@/shared/components/PageHeader';
import { Award } from 'lucide-react';
import SkillsStep from '../components/SkillsStep';

export default function SkillsPage() {
  return (
    <>
      <PageHeader
        title="Skills"
        subtitle="Manage skills for the Skills Matrix"
        icon={<Award className="size-7 text-primary" />}
      />
      <SkillsStep />
    </>
  );
}
